module.exports = __webpack_public_path__ + "9d45cfdd12175bb0d6fa6ac1322185b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/plugin/images/plugin-img005.png
// module id = 915
// module chunks = 3